import React from "react";
import "./NoPage.css";

export default function NoPage() {
  return <div className="main-container">NoPage</div>;
}
